export default "__VITE_ASSET__CdZa17vY__"